var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V18H6.75L6.35 17.65C5.53333 16.8333 4.93767 15.946 4.563 14.988C4.18833 14.03 4.00067 13.0507 4 12.05C4 10.2 4.55433 8.55433 5.663 7.113C6.77167 5.67167 8.21733 4.71733 10 4.25V6.35C8.8 6.78333 7.83333 7.521 7.1 8.563C6.36667 9.605 6 10.7673 6 12.05C6 12.8 6.14167 13.5293 6.425 14.238C6.70833 14.9467 7.15 15.6007 7.75 16.2L8 16.45V14H10V20H4ZM14 19.75V17.65C15.2 17.2167 16.1667 16.4793 16.9 15.438C17.6333 14.3967 18 13.234 18 11.95C18 11.2 17.8583 10.471 17.575 9.763C17.2917 9.055 16.85 8.40067 16.25 7.8L16 7.55V10H14V4H20V6H17.25L17.65 6.35C18.4667 7.16667 19.0627 8.05433 19.438 9.013C19.8133 9.97167 20.0007 10.9507 20 11.95C20 13.8 19.446 15.446 18.338 16.888C17.23 18.33 15.784 19.284 14 19.75Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.5813c6dc2e42e6ce90553ec378b31e3e.svg";
export { ForwardRef as ReactComponent };